import { connect } from 'react-redux'

import {
  doInvalidateNoteDraft,
  doUpdateAndSendComment,
  selectCommentIsSendable,
  selectNoteDraft,
} from 'ducks/drafts'

import { selectShowMentionSelector } from 'selectors/mentions'

import NoteForm from './view'

const select = state => ({
  isDraftSendable: selectCommentIsSendable(state),
  noteDraft: selectNoteDraft(state),
  showMentionSelector: selectShowMentionSelector(state),
})

const perform = dispatch => ({
  doDeleteDraft: ticketId => dispatch(doInvalidateNoteDraft(ticketId)),
  updateAndSendDraft: (ticketId, prop, val) =>
    dispatch(doUpdateAndSendComment(ticketId, prop, val)),
})

export default connect(select, perform)(NoteForm)
